import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "validation-page-container" }
const _hoisted_2 = {
  key: 0,
  class: "card loading-card"
}
const _hoisted_3 = {
  key: 1,
  class: "card success-card"
}
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "badge-devis" }
const _hoisted_6 = { class: "success-message" }
const _hoisted_7 = { class: "card-footer-note" }
const _hoisted_8 = {
  key: 2,
  class: "card error-card"
}
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = { class: "error-message" }
const _hoisted_11 = {
  key: 3,
  class: "card recap-card"
}
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "card-subtitle" }
const _hoisted_15 = { class: "details-list" }
const _hoisted_16 = { class: "detail-row" }
const _hoisted_17 = { class: "detail-label" }
const _hoisted_18 = { class: "detail-value highlight" }
const _hoisted_19 = { class: "detail-row" }
const _hoisted_20 = { class: "detail-label" }
const _hoisted_21 = { class: "detail-value" }
const _hoisted_22 = { class: "detail-row" }
const _hoisted_23 = { class: "detail-label" }
const _hoisted_24 = { class: "detail-value" }
const _hoisted_25 = { class: "detail-row" }
const _hoisted_26 = { class: "detail-label" }
const _hoisted_27 = { class: "detail-value amount-value" }
const _hoisted_28 = {
  key: 0,
  class: "info-box already-validated"
}
const _hoisted_29 = { class: "actions-container" }
const _hoisted_30 = {
  key: 0,
  class: "pdf-error-banner",
  role: "alert"
}
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "help-mention" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoadingInitial)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_LoaderComponent, {
            text: _ctx.$t('devisValidation.loading') || 'Chargement des informations du devis...'
          }, null, 8, ["text"])
        ]))
      : (_ctx.isSuccess)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "icon-container success-icon" }, [
              _createElementVNode("svg", {
                width: "48",
                height: "48",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }),
                _createElementVNode("polyline", { points: "22 4 12 14.01 9 11.01" })
              ])
            ], -1)),
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('devisValidation.success.title') || 'Devis validé avec succès !'), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('devisValidation.devisNumber') || 'Devis n°') + " " + _toDisplayString(_ctx.devisNumeroVersion), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('devisValidation.success.message') || 'La commande a été transmise. L’état Commandé sera visible dans l’outil de chiffrage sous 15 minutes maximum.'), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('devisValidation.closeTab') || 'Vous pouvez fermer cet onglet.'), 1)
          ]))
        : (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"icon-container error-icon\" data-v-82047b6e><svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-82047b6e><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-82047b6e></circle><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"12\" data-v-82047b6e></line><line x1=\"12\" y1=\"16\" x2=\"12.01\" y2=\"16\" data-v-82047b6e></line></svg></div>", 1)),
              _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.$t('devisValidation.error.title') || 'Impossible de valider le devis'), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1)
            ]))
          : (_ctx.devisDetails)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h1", _hoisted_13, _toDisplayString(_ctx.$t('devisValidation.recap.title') || 'Validation de commande'), 1),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('devisValidation.recap.subtitle') || 'Veuillez confirmer la commande de ce devis.'), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('devisValidation.devisNumber') || 'Devis n°') + " :", 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.devisNumeroVersion), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('devisValidation.project') || 'Projet') + " :", 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.devisDetails.libelleProjet || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('devisValidation.object') || 'Objet') + " :", 1),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.devisDetails.objet || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('devisValidation.amount') || 'Montant') + " :", 1),
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.formattedMontant), 1)
                  ])
                ]),
                (_ctx.devisDetails.dejaValide)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "info-icon" }, "ℹ️", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('devisValidation.alreadyValidated') || 'Ce devis a déjà été validé.'), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_29, [
                  (_ctx.pdfErrorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.pdfErrorMessage), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.devisDetails.isPdfPresent)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-pdf",
                        disabled: _ctx.isPdfLoading,
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPdf && _ctx.openPdf(...args)))
                      }, [
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "btn-icon" }, "📄", -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.isPdfLoading ? (_ctx.$t('devisValidation.pdfLoading') || 'Chargement PDF...') : (_ctx.$t('devisValidation.viewPdf') || 'Visualiser le devis (PDF)')), 1)
                      ], 8, _hoisted_31))
                    : _createCommentVNode("", true),
                  (!_ctx.devisDetails.dejaValide)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn btn-confirm",
                        disabled: _ctx.isConfirming,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmOrder && _ctx.confirmOrder(...args)))
                      }, [
                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "btn-icon" }, "✔", -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.isConfirming ? (_ctx.$t('devisValidation.confirming') || 'Validation en cours...') : (_ctx.$t('devisValidation.confirmButton') || 'Commander le devis')), 1)
                      ], 8, _hoisted_32))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('devisValidation.helpMention') || 'Cette action passera automatiquement le devis à l’état « Commandé » dans l’outil de chiffrage.'), 1)
              ]))
            : _createCommentVNode("", true)
  ]))
}